import { render, staticRenderFns } from "./FourthSection.vue?vue&type=template&id=2c56b05f&scoped=true&"
import script from "./FourthSection.vue?vue&type=script&lang=js&"
export * from "./FourthSection.vue?vue&type=script&lang=js&"
import style0 from "./FourthSection.vue?vue&type=style&index=0&id=2c56b05f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c56b05f",
  null
  
)

export default component.exports